import '../common/pollyfills'
import tippy from 'tippy.js';
import jsonTransform from './flatten-get-stream-json';
import GetStreamAPI from '../common/get-stream-api';
import sanitizeHtml from 'sanitize-html';
import NewContentNotificationService from './new-content-notification.service';
import EvaluatedNotificationService from './evaluated-notification.service'
import DownloadAttachmentService from './download-attachment.service'
import downloadImage from '../../assets/svg/Download.svg';
import attachFileImage from '../../assets/svg/attachment.svg';

const { el, elRemove, setGlobalsForDomWrapper } = require("./helper");
const { initSentry, htmlSubstring } = require("../common/helper");
const config = require('../../config');

export class NotificationComponent {

    constructor() {
        initSentry();
        this.copyOfRenderedJson = {};
        this.bindedClickEventsArr = [];
        this.options = {};
    }

    // Function to render notification template
    // 1. Initialise Notification Json
    // 2. Genrate DropDown html from the notification Json
    // 3. Render Notification on given div id with html generated
    init(notificationContainerId, options = {}) {
        this.options = options;
        if(options.apiGatewayUrl) {
            GetStreamAPI.setGlobalsForApiCalls({
                apiGatewayUrl: options.apiGatewayUrl
            })
        }
        setGlobalsForDomWrapper(notificationContainerId);
        this.generateNextRenderableJson(true).then(res => {
            this.options.notificationContainerId = notificationContainerId;
            this.copyOfRenderedJson = res;
            this.generateAllNotificationDropdown();
        }).catch((err)=>{
            console.log(err);
            throw err;
        });
    }

    generateAllNotificationDropdown() {
        let html = this.generateDropDown(this.copyOfRenderedJson);
        this.renderNotifications(this.options.notificationContainerId, html);
        this.eventsBind();
        tippy('.tippyTooltip', {
            theme: 'light'
        });
        let template = el('#notification-dropdown-menu');
        template.style.display = 'block';
        /* 
        * For NEMO-2562 "See older notifications" is missing on some mobile devices
        * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        */
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight;
        // Then we set the value in the --vh custom property to the root of the document
        template.style.setProperty('--vh', `${vh}px`);

        tippy('#tippyDropdownMenuButton', {
            content: template,
            placement: 'bottom-start',
            flip: false,
            trigger: 'click',
            interactive: true,
            arrow: false,
            distance: 0
        });
    }

    eventsBind(){
        // Adding event for close button
        el(`button.close`).addEventListener('click', () => {
            el('#tippyDropdownMenuButton')._tippy.hide();
        });

        const dummyCloseButton = el(`button.close-dummy`);
        if(dummyCloseButton) {
            dummyCloseButton.addEventListener('click', () => {
                el('#tippyDropdownMenuButton')._tippy.hide();
            });
        }
        
        const seeOlderLink = el(`#see-older-notification`);
        if(seeOlderLink) {
            seeOlderLink.onclick = (e) => {
                this.seeOlderNotifications();
                e.preventDefault();
                e.stopPropagation();
            }
        }
        this.bindedClickEventsArr.forEach(clickEventHanlder => clickEventHanlder());
        this.bindedClickEventsArr = [];
    }

    // Function to fill given html in the container of given id
    renderNotifications(notificationContainerId, html) {
        let element = document.getElementById(notificationContainerId);
        element.innerHTML = html;
    }

    // Function to generate stringify html of DropDown from given notification json
    generateDropDown(json) {
        const unReadCount = json.unread;
        return `
            <div class="tippy-dropdown notification-dropdown">
                <a href="javascript:void(0);" qid="ntf-1" id="tippyDropdownMenuButton">
                    <i class="nemo-font nemo-bell" aria-hidden="true"></i>
                    ${unReadCount > 0 ? `<span aria-hidden="true" class="count readCount">${unReadCount}</span>` : ''}
                    <span class="sr-only">Notification</span>
                </a>
                <div class="tippy-dropdown-menu" id="notification-dropdown-menu" onclick="event.stopPropagation();" style="display: none;">
                    <div class="tippy-dropdown-header notification-heading ${json.count <= 0 ? 'pb-2' : ''}">
                        <div class="heading d-flex align-items-center">
                            <h2 aria-labelledby="tippyDropdownMenuButton">Notifications <span class="readCount">${unReadCount ? `(${unReadCount})` : ''}</span></h1>
                            <button type="button" class="close ml-auto" id="close-btn" aria-label="Close" qid="ntf-2">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="hl"></div>
                    </div>
                    <div class="notification-body"> 
                        <div class="notification-items-wrapper" id="all-notification-items-wrapper">
                        ` +
            this.noNotificationCheckOrGenerateDropDownItem(json)
            + ` 
                        </div>`
                        +
                        this.addDummyCloseBtn(json) +`
                    </div>
                </div>
            </div>
            <div id="notification-loader-container" class="hide-loader">
                <div class="loader">
                </div>
            </div>
        `;
    }
    
    noNotificationCheckOrGenerateDropDownItem(json) {
        if (json.count <= 0)
            return '<p class="tippy-dropdown-item py-1 pl-4 no-notifications">No notifications yet!</p>';
        else
            return this.generateDropDownItem(json)
    }
    /*NEMO-17358
    Added a dummy transparent close button so that 
    when user presses tab key from "see older notification" link 
    the focus goes to close button before going out to the header */         
    addDummyCloseBtn(json) {
        if (json.count > 0)
            return `
            <button type="button" class="close-dummy ml-auto" id="close-btn-dummy" aria-label="Close" qid="ntf-2">
            <span aria-hidden="true">&times;</span>
            </button>`;
        else
            return ``;
    }
    
    // Loop on notification array to generate dropdown items
    generateDropDownItem(json) {
        let str = '';
        for (let i in json.results) {
            let mappedJson = json.results[i];
            if (mappedJson.entities.length > 0 && !mappedJson.isNotTimeBasedHeadingNeeded)
                str += `<p class="tippy-dropdown-header time-related-title">${mappedJson.title}</p>`
            for (let j in mappedJson.entities) {
                let notification = mappedJson.entities[j];
                ['title', 'details','reference'].forEach((key)=>{
                    if (key == 'details' && notification.verbInfo && notification.verbInfo.verb == "class_announcement") {
                        notification[key] = this.sanitizeHTMLText(notification[key], 'class_announcements_description');
                    } else {
                        notification[key] = this.sanitizeHTMLText(notification[key]);
                    }
                        
                });
                str += `
                <button class="tippy-dropdown-item d-block" qid="ntf-3${notification.qidIndex}">
                    <div class="dropdown-body d-flex flex-start">
                        <div class="${(['class', 'report', 'lock', 'unlock'].indexOf(notification.icon) > -1) ? 'class-circle' : 'class-square'} d-flex align-items-center justify-content-center">
                            ${notification.imageSrc != "" ? `<img src="${notification.imageSrc}" class="img-fluid" alt="">` : ""}
                            ${notification.svg !== ''
                                ? notification.svg 
                                : notification.icon == 'class' 
                                    ? '<i class="nemo-font nemo-class" aria-hidden="true"></i>' 
                                    : notification.icon == 'message' 
                                        ? '<i class="nemo-font nemo-message" aria-hidden="true"></i>' 
                                        : '<i class="nemo-font nemo-assignment" aria-hidden="true"></i>'}
                            <div class="img-overlay ${(['class', 'report', 'lock', 'unlock'].indexOf(notification.icon) > -1) ? ' circle' : 'square'}"></div>
                        </div>
                        <div class="content d-flex flex-column">
                            <h3 class="title d-flex mb-1" aria-level="3">
                                <div class="d-flex flex-column">
                                    <div class="d-flex align-items-center">
                                        ${(!notification.is_read && ['report', 'lock', 'unlock'].indexOf(notification.icon) === -1) ? '<div class="circle mark-read-circle"></div>' : ''}
                                        ${notification?.verbInfo?.verb == "class_announcement" ?
                                            `<p>${this.ellipsify(notification.title,28)}</p>` :
                                            `<p> ${(!notification.is_read && ['report', 'lock', 'unlock'].indexOf(notification.icon) > -1) ? '<span class="circle d-inline-block mark-read-circle"></span>' : ''}
                                            ${notification.title}
                                            </p>`}
                                    </div>
                                    <p class="tippyTooltip ellipsis" data-tippy-content="${notification.reference}">${notification.reference}</p>
                                </div>
                                ${notification.warning ? '<i class="nemo-font nemo-warning ml-auto mr-2" aria-hidden="true"> </i>' : ''}
                            </h3>
                            <div class="detail mb-2">
                            ${notification?.verbInfo?.verb == "class_announcement" ? htmlSubstring(notification.details,60) : notification.details}
                            </div>
                            <p class="time mb-2">${notification.elapsedTime}</p>
                        </div>
                        <div class="right-arrow ml-2">
                            <i class="fa fa-chevron-right" aria-hidden="true"></i>
                        </div>
                    </div>
                </button>
                `
                notification.qid = `ntf-3${notification.qidIndex}`;
                this.bindedClickEventsArr.push(() => { this.bindClickEventOnEachNotification(notification) });
            }
        }
        if (json.next) {
            str += `
                <div class="action-buttons d-flex justify-content-between align-items-center" id="action-buttons">
                    <a class="ml-auto py-3" id="see-older-notification" href="javascript:void(0);" qid="ntf-4">See older notifications</a>
                </div>`
        }
        return str;
    }

    // Fetch 5 notification from api and transform it renderable Json 
    async generateNextRenderableJson(isClassInitialising) {
        const nextNotificationJSON = await GetStreamAPI.getNextNotificationsFromCache(isClassInitialising);
        const renderableJson = jsonTransform(nextNotificationJSON);
        return renderableJson;
    };

    seeOlderNotifications() {
        let seeOlderNotificationsElement = el("#see-older-notification");
        // seeOlderNotificationsElement.removeEventListener('click', this.seeOlderNotifications);
        seeOlderNotificationsElement.insertAdjacentHTML('beforeend',`
                <i class="fa fa-spinner ml-1 fa-spin" aria-hidden="true"></i>
        `);
        this.generateNextRenderableJson(false).then(notificationData => {
            notificationData.results = this.updateTimeBasedHeadingFlag(notificationData.results);
            let html = this.generateDropDownItem(notificationData);

            elRemove("#action-buttons");
            
            el('#notification-dropdown-menu .notification-items-wrapper').insertAdjacentHTML('beforeend',html);
            let seeOlderNotificationsElement = el("#see-older-notification");
            if (seeOlderNotificationsElement) {

                el(`#see-older-notification`).onclick = (e) => {
                    this.seeOlderNotifications();
                    e.preventDefault();
                    e.stopPropagation();
                }

            }
            this.bindedClickEventsArr.forEach(clickEventHanlder => clickEventHanlder());
            this.bindedClickEventsArr = [];
            tippy('.tippyTooltip', {
                theme: 'light'
            });
        }).catch((err)=>{
            console.log(err);
            throw err;
        });
    }

    updateTimeBasedHeadingFlag(notificationData) {
        for (let notification of notificationData) {
            const findNotificationHeadingRendered = this.copyOfRenderedJson.results.find(copyJson => copyJson.title == notification.title);
            notification.isNotTimeBasedHeadingNeeded = findNotificationHeadingRendered.entities.length > 0;
            findNotificationHeadingRendered.entities.push(...notification.entities);
        }
        return notificationData;
    }

    
    getNewContentRedirectURL(userSpaceAndClassDetails, bundleCode, productCode) {
        let redirectURL = '';
        if (!userSpaceAndClassDetails?.productDetails || !userSpaceAndClassDetails?.space_key) return redirectURL;

        const productDetails = userSpaceAndClassDetails.productDetails;
        const baseURL = window.location.origin;
        const productType = productDetails['ext-product']?.type;
        if (bundleCode === config.ieltsBundleCode) {
            redirectURL = `${baseURL}/ieltsi/product/${productCode}`;
        }
        else if (productType === 'OLP') {
            const rolePath = (userSpaceAndClassDetails.role === 'student') ? 'learner' : 'teacher';
            const learningPath = productDetails.meta && productDetails.meta['learning-path'];
            if (learningPath === '3') {

                redirectURL = `${baseURL}/dashboard/${rolePath}/${userSpaceAndClassDetails.space_key}/resourcebank/${productCode}`;

                if (userSpaceAndClassDetails.classId) {
                    redirectURL += `/${userSpaceAndClassDetails.classId}`;
                }

            } else if (learningPath === '2') {

                redirectURL = `${baseURL}/nlp/${rolePath}/${userSpaceAndClassDetails.space_key}`;

                if (userSpaceAndClassDetails.classId) {
                    redirectURL += `/class/${userSpaceAndClassDetails.classId}`;
                }
                redirectURL += `/product/${productCode}`;

            } else {

                redirectURL = `${baseURL}/learning-path/${rolePath}/${userSpaceAndClassDetails.space_key}/product/${productCode}`;

                if (userSpaceAndClassDetails.classId) {
                    redirectURL += `/class/${userSpaceAndClassDetails.classId}`;
                }
            }
        } else if (productType === 'imgbook') {

            redirectURL = `${baseURL}/foc/${userSpaceAndClassDetails.space_key}/product/${bundleCode}/studentbook/${productCode}/view`;

        } else {

            redirectURL = `${baseURL}/dashboard/teacher/${userSpaceAndClassDetails.space_key}/bundle/${bundleCode}/digital-component/${productCode}`;

        }

        return redirectURL;
    }

    showLoader() {
       let loader = el('#notification-loader-container');
        if(loader?.classList){
            loader.classList.remove("hide-loader")
            loader.classList.add("show-overlay-loader")
        }
    }

    // Function to generate stringify html of DropDown for a given notification
    generateSingleNotificationDropdown(notification) {
        return `
            <div class="tippy-dropdown-header notification-heading single-notification-heading">
                <div class="heading d-flex align-items-center">
                    <button type="button" class="back-button" id="back-to-all-btn" aria-label="Back To Notifications" qid="ntf-5">
                        <span class="fa fa-chevron-left back-button-icon" aria-hidden="true"></span>
                    </button>
                    <h2 class="pt-0 mb-0 pb-0">Announcement</h2>
                    <button type="button" class="close single-notification-close ml-auto" id="single-notification-close-btn" aria-label="Close" qid="ntf-6">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="hl"></div>
                <div class="d-flex align-items-center justify-content-between">
                    <h2 class="notification-title">${this.sanitizeHTMLText(notification.title)}</h2>
                    ${notification?.verbInfo?.verb == "class_announcement" && notification?.verbInfo?.attachments && notification?.verbInfo?.attachments?.length ? 
                        `<img class="attachment-img" src="${attachFileImage}" alt="attachment-img"/>` : ""}
                </div>
                <p class="notification-reference mb-0">${notification.reference}</p>
            </div>
            <div class="notification-body single-notification-body"> 
                <div class="notification-items-wrapper">
                    <div class="single-notification-detail detail">${notification.details}</div>
                    ${this.renderAttachments(notification?.verbInfo?.attachments)}
                    <p class="time mb-0">${notification.elapsedTime}</p>
                </div>
            </div>
        `;
    }

    sanitizeHTMLText(text, key = null) {
        let cleanText;
        if (key == 'class_announcements_description') {
            cleanText = sanitizeHtml(text, {
                allowedTags: [ 'br', 'p', 'b', 'strong', 'em', 'i', 'u',  'a' ],
                allowedAttributes: {
                  'a': [ 'href', 'rel', 'target' ]
                },
                allowedIframeHostnames: [],
                disallowedTagsMode: 'discard',
                allowedSchemes: [ 'http', 'https'],
                parseStyleAttributes: false,
                nestingLimit: 5
            });
        } else {
            cleanText = sanitizeHtml(text, {
                allowedTags: [],
                allowedAttributes: {},
                allowedIframeHostnames: [],
                disallowedTagsMode: 'discard',
                parseStyleAttributes: false,
                nestingLimit: 0
            });
        }
        return cleanText;
    }

    ellipsify(stringText, characterLimit) {
        if (stringText.length > characterLimit) {
            return (stringText.substring(0, characterLimit) + "...");
        }
        else {
            return stringText;
        }
    }

    bindClickEventOnEachNotification(notification) {
        let notificationElement = el(`[qid='${notification.qid}']`);
        notificationElement.addEventListener('click', async (e) => {
            if (!notification.is_read) {
                await GetStreamAPI.markReadActivity(notification);
                // update notification count and read icon
                notification.is_read = true;
                const unReadCount = --this.copyOfRenderedJson.unread;
                if (unReadCount != 0) {
                    el(`#tippyDropdownMenuButton .readCount`).innerText = unReadCount;
                    el(`#notification-dropdown-menu .readCount`).innerText = `(${unReadCount})`;
                } else {
                    elRemove(`#tippyDropdownMenuButton .readCount`);
                    el(`#notification-dropdown-menu .readCount`).innerText = '';
                }
                let markReadCircleElement = notificationElement.querySelector('.mark-read-circle');
                markReadCircleElement?.parentNode?.removeChild(markReadCircleElement);
            }
            let redirectLink = notification.redirectLink;
            
            if(notification?.verbInfo?.verb ==="new_content_umbrella" ){
                
                this.showLoader();
                
                const bundleCode = notification.verbInfo.metadata?.bundleCode;
                const productCode = notification.verbInfo.metadata?.productCode;
                let userSpaceAndClassDetails;
                
                if (bundleCode && productCode) {
                    userSpaceAndClassDetails = await NewContentNotificationService.getRedirectInfoForNewContent(bundleCode, productCode);
                } 
                
                if(userSpaceAndClassDetails && userSpaceAndClassDetails.success !== false){
                    redirectLink = this.getNewContentRedirectURL(userSpaceAndClassDetails, bundleCode, productCode);
                }
            }

            if(notification?.verbInfo?.verb ==="evaluated") {
                this.showLoader(); 
                const classId = notification.verbInfo.metadata?.classId;
                const spaceId = notification.verbInfo.metadata?.spaceId;
                const itemCode = notification.verbInfo.metadata?.itemCode;
                const productCode = notification.verbInfo.metadata?.productCode;
                const lpVersion = notification.verbInfo.metadata?.lp_version;

                if (spaceId && classId) {
                    const redirectInfo = await EvaluatedNotificationService.getRedirectInfoForEvaluated(spaceId, classId, productCode);                
                    redirectLink = this.getEvaluatedRedirectURL(redirectInfo, spaceId, classId, productCode, lpVersion, itemCode);
                }

            }
            if(notification?.verbInfo?.verb === "class_announcement") {
                let html = this.generateSingleNotificationDropdown(notification);
                this.renderNotifications('notification-dropdown-menu', html);
                el(`#notification-dropdown-menu`).classList.add("single-notification-dropdown-menu");
                el(`#back-to-all-btn`).addEventListener('click', () => {
                    this.generateAllNotificationDropdown();
                    el('#tippyDropdownMenuButton')._tippy.show();
                });
                el(`#single-notification-close-btn`).addEventListener('click', () => {
                    el(`#notification-dropdown-menu`).classList.remove("single-notification-dropdown-menu");
                    this.generateAllNotificationDropdown();
                });
                if(notification?.verbInfo?.attachments[0] && el(`#notifications-attachment-${notification?.verbInfo?.attachments[0]["doc-id"]}`)){
                    el(`#notifications-attachment-${notification?.verbInfo?.attachments[0]["doc-id"]}`).addEventListener('click', () => {
                        this.downloadAttachedFile(notification);
                    })
                }
            } else {
                window.location.href = redirectLink;
            }
            
            e.preventDefault();
            e.stopPropagation();
        });
    }

    // function to render attachments of a announcement
    renderAttachments(attachments) {
        let attachmentStates = DownloadAttachmentService.getDownloadAttachmentStates();
        if (attachments && attachments.length > 0) {
            let attachmentHtml = '<div class="notification-attachments d-flex">';
            attachments.forEach((attachment, index) => {
                attachmentHtml += `
                <a id="notifications-attachment-${attachment['doc-id']}" class="show-uploaded-files d-flex align-items-start ${attachmentStates[attachment['doc-id']] ? 'disabled' : ''}" href="javascript:void(0);" qid="${this.sanitizeHTMLText(attachment.file_name)}">
                    <img class="attachment-img" src="${downloadImage}" alt="${this.sanitizeHTMLText(attachment.file_name)}"/>
                    <span class="attachment-font">${this.sanitizeHTMLText(attachment.file_name)}</span>
                </a>
                <span id="attachment-loader-${attachment['doc-id']}" class="ml-2 ${attachmentStates[attachment['doc-id']] ? '' : 'hide-loader'}">
                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                    <span class="sr-only">Downloading</span>
                </span>
                `;
            });
            attachmentHtml += '</div>';
            return attachmentHtml;
        } else {
            return '';
        }
    }
    
    downloadAttachedFile(notification) {
        const classId = notification.verbInfo?.classId;
        const spaceId = notification.verbInfo?.spaceId;
        const foreign_id = notification.verbInfo?.foreign_id;
        const link = el(`#notifications-attachment-${notification?.verbInfo?.attachments[0]["doc-id"]}`);
        const loader = el(`#attachment-loader-${notification?.verbInfo?.attachments[0]["doc-id"]}`);
        if(link){
            link.classList.add('disabled');
        }
        if(loader){
            loader.classList.remove('hide-loader');
        }
        const signedURLpromiseforDownloadAttachment = DownloadAttachmentService.getSignedURLforDownloadAttachment(spaceId, classId, foreign_id, notification?.verbInfo?.attachments[0]);
        signedURLpromiseforDownloadAttachment.then((res) => {
            if (res.success) {
                this.downloadAttachment(notification?.verbInfo?.attachments[0], res.signedURL, link, loader);
            } else {
                console.log(res);
                if(link){
                    link.classList.remove('disabled');
                }
                if(loader){
                    loader.classList.add('hide-loader');
                }
          }
        }).catch((e) => {
            console.log(e);
            if(link){
                link.classList.remove('disabled');
            }
            if(loader){
                loader.classList.add('hide-loader');
            }
        });
    }
    
    downloadAttachment(attachmentData, signedURL) {
        const fileName = attachmentData.file_name;
        let xhr = new XMLHttpRequest();
        xhr.open('GET', signedURL, true);
        xhr.responseType = 'arraybuffer';
        const successHandler = ((e) => {
            let blob = new Blob([xhr.response], { type: attachmentData.type });
            const tempAnchor = document.createElement('a');
            tempAnchor.setAttribute('id', attachmentData['doc-id']);
            tempAnchor.setAttribute('download', fileName);
            tempAnchor.setAttribute('hidden', 'true');
            tempAnchor.classList.add('hidden', 'd-none');
            tempAnchor.setAttribute('href', window.URL.createObjectURL(blob));
            document.body.appendChild(tempAnchor);
            tempAnchor.click();
            document.body.removeChild(tempAnchor);
            const link = el(`#notifications-attachment-${attachmentData['doc-id']}`);
            const loader = el(`#attachment-loader-${attachmentData['doc-id']}`);
            DownloadAttachmentService.changeDownloadState(attachmentData);
            if(link){
                link.classList.remove('disabled');
            }
            if(loader){
                loader.classList.add('hide-loader');
            }
        });
        const errorHandler = ((e) => {
            console.log(e);
            document.body.removeChild(tempAnchor);
        });
        const abortHandler = ((e) => {
            document.body.removeChild(tempAnchor);
        });
        xhr.addEventListener('load', successHandler);
        xhr.addEventListener('error', errorHandler);
        xhr.addEventListener('abort', abortHandler);
        xhr.send();
    }

    getEvaluatedRedirectURL(redirectInfo, spaceId, classId, productCode, lpVersion, itemCode) {
        const productData = redirectInfo?.productData;
        const isAssignmentOnly = productData?.activation?.gated?.student && productData.activation.gated.student['assignments-only'];    
        if (isAssignmentOnly) {
            const assignmentData = this.getAssignmentForItemCode(redirectInfo.assignmentsData, itemCode);
            return `${window.location.origin}/learning-path/learner/${spaceId}/class/${classId}/product/${productCode}/assignment/${assignmentData?.assigned_path_id}/item/${itemCode?.split('/').join('%2F')}`;  
        }
        else {
            if(lpVersion === '2') {
                return `${window.location.origin}/nlp/learner/${spaceId}/class/${classId}/product/${productCode}/view/item/${itemCode?.split('/').join('%2F')}`;    
            }    
            return `${window.location.origin}/learning-path/learner/${spaceId}/product/${productCode}/class/${classId}/item/${itemCode?.split('/').join('%2F')}`;
        }            
    }

    getAssignmentForItemCode(assignments, itemCode) {
        let assignmentData;
        if (!assignments?.entities) return;
        assignmentData = assignments.entities.find(assignment => 
            assignment?.items?.some(item => item['item-code'] === itemCode)
        );
        return assignmentData;
    }
}
// Load Event Fired
(function fireEventOnNotificationScriptLoaded() {
    let evt = new CustomEvent('cambridgeOne.notificationComponentLoaded');
    console.log("Notifications File Loaded")
    window.dispatchEvent(evt);
})();